<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <data-table
          :filters="filters"
          :limit="10"
          url="/company_emails"
          fields="email,forwarding,status,name"
          content="companyEmailList"
          searchFields="name,email,forwarding">
          <template slot="title">
            <v-layout row wrap>
              <v-flex md9 class="headline mt-3">
                Emails
              </v-flex>
              <v-flex md3 class="text-xs-right">
                <v-btn class="k-orange-linear white--text mt-2 mr-0" large @click="dialog = !dialog">Agregar emails</v-btn>
              </v-flex>
            </v-layout>
          </template>
          <template slot="navigation-bar">
              <v-flex lg10>
              <v-text-field
                v-model="filters.search"
                label="Buscar..."
                color="black"
                solo>
              </v-text-field>
            </v-flex>
            <v-flex lg2 pl-2>
              <v-select
                v-model="filters.status"
                :items="statuses"
                item-value="value"
                item-text="name"
                class="white--text"
                color="grey"
                solo>
              </v-select>
            </v-flex>
          </template>
        </data-table>
      </v-flex>
    </v-layout>
    <save-dialog
      :title="title"
      :route="route"
      :form="form"
      :edit="edit"
      :dialog="dialog"
      :more="false"
      :hasMore="false">
      <template slot="content">
        <v-layout row wrap>
          <v-flex md12>
            <v-text-field
              color="black"
              label="Nombre"
              v-model="form.name"
              :error-messages="errors.collect('name')"
              v-validate="'required|max:100'"
              data-vv-name="name"
              data-vv-as="nombre"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md6 pr-5>
            <v-text-field
              color="black"
              label="Email"
              v-model="form.email"
              @keypress="preventChar($event)"
              :error-messages="errors.collect('email')"
              v-validate="'required|max:100|cktia'"
              data-vv-name="email"
              data-vv-as="email"
            ></v-text-field>
          </v-flex>
          <v-flex md6>
            <v-select
              :items="domains"
              v-model="form.domain"
              label="Dominio"
              item-text="domain"
              item-value="domain"
              :error-messages="errors.collect('email')"
              v-validate="'required|max:100'"
              color="black"
              data-vv-name="domain"
              data-vv-as="dominio">
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              color="black"
              label="Responde a"
              v-model="form.forwarding"
              :error-messages="errors.collect('forwarding')"
              v-validate="'required|email|max:100'"
              data-vv-name="forwarding"
              data-vv-as="responde a"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </template>
    </save-dialog>
    <delete-dialog
      :dialog="deleteOptions.dialog"
      :id="deleteOptions.id"
      :text="deleteOptions.text"
      :url="route">
    </delete-dialog>
  </v-container>
</template>

<script>
import Vue from 'vue';
import EventBus from '@/event-bus';
import { Validator } from 'vee-validate';
import dataTable from '@/components/global/DataTable';
import dataTableListMixin from '@/mixins/dataTableList';
import companyEmailList from '@/components/company_email/CompanyEmailList';
import deleteDialog from '@/components/global/DeleteDialog';
import saveDialog from '@/components/global/SaveDialog';
import saveDialogMixin from '@/mixins/saveDialog';

Vue.component('companyEmailList', companyEmailList);

export default {
  mixins: [
    dataTableListMixin,
    saveDialogMixin,
  ],
  components: {
    'delete-dialog': deleteDialog,
    'data-table': dataTable,
    'save-dialog': saveDialog,
  },
  data() {
    return {
      from: false,
      to: false,
      dialog: false,
      showName: 'email',
      route: 'company_emails',
      fields: 'email,forwarding,name',
      filters: {
        search: '',
        status: '',
      },
      domains: [],
      form: {
        email: '',
        forwarding: '',
        name: '',
      },
      statuses: [
        {
          value: '',
          name: 'Estados',
        },
        {
          value: 'activo',
          name: 'Activos',
        },
        {
          value: 'inactivo',
          name: 'Inactivos',
        },
      ],
    };
  },
  created() {
    EventBus.$on('modalOpened', () => {
      this.axios.get('domains?status=Activo&paginate=0').then((response) => {
        this.domains = response.data;
      }).catch(() => { });
    });
    /* eslint-disable */
    const validator = {
      getMessage(field, args) {
        // will be added to default locale messages.
        // Returns a message.
      },
      validate(value, args) {
        // Returns a Boolean or a Promise that resolves to a boolean.
      },
    };

    Validator.extend('cktia', {
      getMessage: (field) => `No puede cambiar el dominio @cktia.com al ${field}.`,
      validate: (value) => value.includes('@') ? false : true,
    });
  },
  methods: {
    searchElement() {
      this.axios.get(`/${this.route}?fields=${this.fields}`).then((response) => {
        this.form.email = response.data.email.split('@')[0];
        this.form.domain = `@${response.data.email.split('@')[1]}`;
        this.form.name = response.data.name;
        this.form.forwarding = response.data.forwarding;
      });
      this.edit = true;
      this.dialog = true;
    },
    preventChar(event) {
      if (event.key === '@') {
        event.preventDefault();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/company_email/Index.vue